export default __webpack_public_path__ + "static/media/330_business02-it-web.4665f85f.png";